import React from 'react';
import { Link } from "react-router-dom";
import api from "../servicios/api";
import { authHeaders } from "../servicios/auth";

class Listarinfracciones extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            datosCargados: false,
            infracciones: [],
            articulos: [],
            articuloSeleccionado: "",
            mensaje: ""
        }
    }

    

borrarRegistros = (id) => {
    fetch(api + "infracciones/" + id, {
        method: "DELETE",
        headers: authHeaders()
    })
    .then(respuesta => respuesta.json())
    .then((datosRespuesta) => {
        if (datosRespuesta.success === 1) {
            this.setState({
                mensaje: "Infracción eliminada con éxito"
            });

            setTimeout(() => {
                this.setState({ mensaje: "" });
                this.cargarDatos();
            }, 2000);
        } else {
            this.setState({
                mensaje: datosRespuesta.mensaje || "No se pudo eliminar la infracción"
            });
        }
    });
}



cargarDatos() {
    fetch(api + "infracciones", {
        headers: authHeaders()
    })
    .then(respuesta => respuesta.json())
    .then((datosRespuesta) => {
        this.setState({
            datosCargados: true,
            infracciones: datosRespuesta
        });
    });
}

 cargarArticulos() {
    fetch(api + "infracciones/articulos", {
        headers: authHeaders()
    })
    .then(respuesta => respuesta.json())
    .then((datosRespuesta) => {

        

        this.setState({
            articulos: Array.isArray(datosRespuesta) ? datosRespuesta : []
        });
    });
}

filtrarArticulo = (e) => {
    const articulo = e.target.value;

    this.setState({
        articuloSeleccionado: articulo,
        datosCargados: false
    });

    if (articulo === "") {
        this.cargarDatos();
    } else {
        fetch(api + "infracciones/por-articulo/" + articulo, {
            headers: authHeaders()
        })
        .then(respuesta => respuesta.json())
        .then((datosRespuesta) => {

            

            this.setState({
                datosCargados: true,
                infracciones: Array.isArray(datosRespuesta) ? datosRespuesta : []
            });
        })
        .catch(error => {
           
            this.setState({
                datosCargados: true,
                infracciones: [],
                mensaje: "Error al filtrar artículo"
            });
        });
    }
}

    componentDidMount() {
        this.cargarDatos();
        this.cargarArticulos();
    }

    render() {
        const usuario = JSON.parse(localStorage.getItem("usuario"));
        const rol = Number(usuario?.rol);
        const { datosCargados, infracciones, articulos, articuloSeleccionado, mensaje } = this.state;

        if (!datosCargados) {
            return (<div>Cargando...</div>);
        }

        return (
            <div className="card">
                <div className="card-header d-flex gap-2">
    {[1, 2].includes(rol) && (
        <Link className="btn btn-success" to={"/infracciones/crearinfraccion"}>
            Agregar nueva infracción
        </Link>
    )}

    <select
        className="btn btn-primary"
        name="articuloSeleccionado"
        value={articuloSeleccionado}
        onChange={this.filtrarArticulo}
    >
    <option value="">Filtrar por artículo</option>

    {
        articulos.map((item) => (
            <option
                key={item.articulo}
                value={item.articulo}
            >
                Artículo {item.articulo}
            </option>
        ))
    }
</select>
                </div>

                <div className="card-body">
                    {mensaje && (
                        <div className="alert alert-success">
                            {mensaje}
                        </div>
                    )}

                    <h4>Listado General de Infracciones</h4>

                    <table className="table">
                        <thead>
                            <tr>
                                <th>ARTÍCULO</th>
                                <th>INCISO</th>
                                <th>INFRACCIÓN</th>
                                <th>ACCIONES</th>
                            </tr>
                        </thead>

                        <tbody>
                            {
                                infracciones.map((infraccion, index) => (
                                    <tr key={infraccion.idinfraccion}>
                                        
                                        <td>{infraccion.articulo}</td>
                                        <td>{infraccion.inciso}</td>
                                        <td>{infraccion.descripcion}</td>
<td>
    <div className="btn-group">

        {[1, 2].includes(rol) && (
            <Link
                className="btn btn-warning"
                to={"/infracciones/editarinfracciones/" + infraccion.idinfraccion}
            >
                Editar
            </Link>
        )}

        {rol === 1 && (
            <button
                type="button"
                className="btn btn-danger"
                onClick={() => this.borrarRegistros(infraccion.idinfraccion)}
            >
                Borrar
            </button>
        )}

        {rol === 3 && (
            <span className="text-muted">Solo consulta</span>
        )}

    </div>
</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>

                <div className="card-footer text-muted"></div>
            </div>
        );
    }
}

export default Listarinfracciones;